module.exports = __webpack_public_path__ + "static/media/ic_like_filled.f73edd77.svg";